// =============================================================
// VARIANCE — The Executive Command Center
// File      : main.tsx
// Location  : /home/Applications/variance/web/src/main.tsx
// Owner     : VARIANCE frontend application only
// Purpose   : The React entry point. Mounts the App component
//             to the DOM and imports the global CSS.
//
// WHAT THIS FILE TOUCHES
//   - The React DOM renderer.
//
// WHAT THIS FILE DOES NOT TOUCH
//   - The API backend or the database.
// =============================================================

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
